import { createFileRoute } from '@tanstack/react-router'

import { AnnouncementsPage } from '#/modules/announcements/announcements-page'
import { validateListSearch } from '#/shared/lib/list-search'

export const Route = createFileRoute('/_shell/announcements/')({
  component: AnnouncementsPage,
  validateSearch: validateListSearch,
})
